import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest } from '@polkadot/x-rxjs';
import { map, switchMap } from '@polkadot/x-rxjs/operators';
import { memo } from "../util/index.mjs";
var DEFAULT_FLAGS = {
  withController: true,
  withPrefs: true
};
export function waitingInfo(instanceId, api) {
  return memo(instanceId, function () {
    var flags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FLAGS;
    return combineLatest([api.derive.staking.validators(), api.derive.staking.stashes()]).pipe(switchMap(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          nextElected = _ref2[0].nextElected,
          stashes = _ref2[1];

      var elected = nextElected.map(function (a) {
        return a.toString();
      });
      var waiting = stashes.filter(function (v) {
        return !elected.includes(v.toString());
      });
      return api.derive.staking.queryMulti(waiting, flags).pipe(map(function (info) {
        return {
          info: info,
          waiting: waiting
        };
      }));
    }));
  });
}